import { serviceRequest } from 'utils/http';
import { SupportedCountryService } from 'common/api';

export function getLanguagesAPI() {
  return serviceRequest(() =>
    SupportedCountryService.supportedCountryControllerList()
  );
}
